import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { Data, Router } from "@angular/router";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-something-else",
    templateUrl: "./something-else.component.html",
    styleUrls: ["./something-else.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class SomethingElseComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "something-else";
  syndicateName: Data | string;
  constructor(
    public translate: TranslateService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
  ) {
    this.GTMSegment.GTMPopupInitialization("leaveSyndicateReasonPopup-6");
  }

  ngOnInit() {
    this.syndicateName = this.navParams?.data.s_name
    this.translate.get(['something-else.pageTitle']).subscribe((res: string) => {
      this.pageTitle = (res["something-else.pageTitle"])
    }, err => { return (err) })
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }

  closeAndRedirect() {
    this.router.navigateByUrl("/account/helpSupport");
    this.syndicateService?.closeAllDialogs();
  }
}
